export default function Hero() {
  const stats = [
    { value: '5000+', label: '部韩漫作品' },
    { value: '每日50+', label: '同步更新' },
    { value: '100%', label: '永久免费' },
  ];

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/90 via-background-50 to-accent-50/60"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="w-full lg:w-1/2 flex flex-col items-start gap-5">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full whitespace-nowrap">
              全网更新最快的韩漫平台
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight">
              韩漫 - 免费韩漫在线观看平台
            </h1>

            <p className="text-lg md:text-xl text-primary-600 font-heading">
              海量韩漫资源，每日同步更新，全部免费阅读
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
              韩漫为您汇集全网最新最全的韩国漫画资源，涵盖恋爱、奇幻、动作、悬疑等热门题材。每日同步韩网更新，第一时间呈现新章节，无需注册、无需付费，随时随地畅享高品质韩漫在线阅读体验。当前热门作品持续追踪中，热门番外与完结佳作一网打尽。
            </p>

            <div className="flex items-center gap-6 flex-wrap">
              {stats.map((stat) => (
                <div key={stat.label} className="flex items-baseline gap-1.5">
                  <span className="text-2xl md:text-3xl font-heading font-bold text-primary-500 whitespace-nowrap">
                    {stat.value}
                  </span>
                  <span className="text-xs md:text-sm text-foreground-500 whitespace-nowrap">
                    {stat.label}
                  </span>
                </div>
              ))}
            </div>

            <div className="flex items-center gap-3 flex-wrap">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line text-lg"></i>
                开始阅读
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-foreground-700 text-sm font-medium rounded-md border border-background-300 hover:border-primary-300 hover:text-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                热门排行
              </a>
            </div>
          </div>

          <div className="w-full lg:w-1/2 flex items-center justify-center">
            <div className="relative w-full max-w-lg aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20digital%20illustration%20of%20Korean%20manhwa%20webtoon%20reading%20experience%20with%20floating%20colorful%20comic%20panels%20and%20speech%20bubbles%20in%20warm%20coral%20amber%20and%20gold%20tones%20soft%20gradient%20background%20artistic%20composition%20with%20ample%20negative%20space%20modern%20editorial%20design%20aesthetic%20dreamy%20warm%20atmosphere%20high%20detail&width=1200&height=900&seq=hero-kr-comic-01&orientation=landscape"
                alt="韩漫在线阅读 - 免费韩国漫画平台主视觉"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}